<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-head">
            卡密管理
          </div>
          <div class="card-body padding-top0">
            <div class="card-menu">
              <Row>
                <Col :xs="{ span: 24 }" :lg="{ span: 12 }" style="margin: 5px 0">
                <Button type="primary" icon="md-add" @click="addClick" style="margin-right: 10px">新增</Button>
                <Button type="error" icon="md-trash" @click="allDel" :loading="loading"
                  v-show="Selection.length > 0">删除</Button>
                </Col>
                <Col :xs="{ span: 24 }" :lg="{ span: 12 }" style="margin: 5px 0">
                <Input v-model="searchValue" placeholder="搜索">
                <Select v-model="searchType" slot="prepend" style="width: 130px">
                  <Option :value="1">授权码</Option>
                  <Option :value="2">使用者手机号</Option>
                </Select>
                <Button slot="append" icon="ios-search" @click="searchClick"></Button>
                </Input>
                </Col>
              </Row>

            </div>
            <div v-if="data.length == 0">
              <Empty :text="'暂无数据'"></Empty>
            </div>
            <div v-else>
              <Alert show-icon type="error">请勿低于项目最低价出售，否则将解除授权商资格不退款</Alert>
              <Table ref="selection" :columns="columns" :data="data" @on-selection-change="handleSelectChange">
                <template slot-scope="{ row }" slot="card">
                  <span :class="row.status == 1 ? 'del' : ''">
                    {{ row.card }}</span>
                </template>
                <template slot-scope="{ row }" slot="status">
                  <Badge v-if="row.status === 0" status="success" text="未使用" />
                  <Badge v-if="row.status === 1" status="error" text="已使用" />
                </template>
                <template slot-scope="{ row }" slot="action">
                  <Button type="error" size="small" @click="del(row.id)">删除</Button>
                </template>
              </Table>
              <div class="paging">
                <Page :total="Number(total)" :current="pageIndex" :page-size="pageSize" :simple="$store.state.isMobile"
                  @on-change="pageChange" @on-page-size-change="pageSizeChange" show-total show-sizer show-elevator />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal v-model="showCreate" :width="600" :styles="{top: '50px'}" :title="'新增卡密'" :loading="creating"
      @on-ok="addSave()">
      <Form ref="create" :model="createData" :rules="createRules" :label-width="130">
        <FormItem label="所属项目：" prop="project_id" :class="!$store.state.isMobile ? 'w50' : ''">
          <Select v-model="createData.project_id" placeholder="请选择项目">
            <Option v-for="item in projectList" :key="item.id" :value="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="所属授权商：" prop="user_id" v-if="$store.state.auth == 1">
          <Select v-model="createData.user_id" placeholder="请选择授权商">
            <Option v-for="item in UserList" :key="item.id" :value="item.id">{{ item.phone }}</Option>
          </Select>
        </FormItem>
        <FormItem label="授权天数：" prop="authday" v-if="$store.state.auth == 1">
          <InputNumber :min="1" v-model="createData.authday"></InputNumber>
        </FormItem>
        <FormItem label="添加数量：" prop="count">
          <InputNumber :min="1" :max="50" :step="1" v-model="createData.count"></InputNumber>
        </FormItem>


      </Form>
    </Modal>
    <Modal v-model="showCard" title="卡密列表">
      <p v-for="item in cardList" :key="item.id">{{item.card}}</p>
    </Modal>
  </div>
</template>

<script>
  import {
    getProject,
    getUserAll,
    getCard,
    postCard,
    delCard
  } from "@/api";

  export default {
    data() {
      return {
        showCard: false,
        Selection: [],
        pageIndex: 1,
        pageSize: 10,
        total: "",
        searchValue: "",
        searchType: 1,
        showCreate: false,
        creating: true,
        loading: false,
        createData: {
          project_id: "",
          user_id: "",
          authday: "99999",
          count: "",

        },
        createRules: {
          project_id: [{
            required: true,
            message: "请选择项目",
          }],
          user_id: [{
            required: true,
            message: "请选择授权商",
          }],
          authday: [{
            required: true,
            message: "请输入授权天数",
          }],
          count: [{
            required: true,
            message: "请输入添加数量",
          }],

        },
        columns: [{
            type: "selection",
            width: 60,
            align: "center",
          },
          {
            title: "授权码",
            slot: "card",
            align: "center",
            minWidth: 150,
          }, {
            title: "所属项目",
            key: "project_name",
            align: "center",
            minWidth: 200,
          }, {
            title: "授权商ID",
            key: "user_id",
            align: "center",
            minWidth: 100,
          },
          {
            title: "授权天数",
            key: "authday",
            align: "center",
            minWidth: 150,
          }, {
            title: "使用者",
            key: "phone",
            align: "center",
            minWidth: 180,
          },

          {
            title: "状态",
            align: "center",
            slot: "status",
            minWidth: 100,
          },
          {
            title: "操作",
            minWidth: 130,
            align: "center",
            slot: "action",
          },
        ],
        data: [],
        projectList: [],
        UserList: [],
        cardList: []
      };
    },
    created() {
      this._getProject();
      this._getData()
      if (this.$store.state.auth == 1) {
        this._getUser()
        this._getProject()
      }

    },
    watch: {
      searchValue(newVal, oldVal) {
        if (newVal == "") {
          this.searchClick()
        }
      },
    },
    methods: {
     
      searchClick() {
        (this.pageIndex = 1), (this.pageSize = 10), this._getData();
      },
      // 获取项目列表
      _getProject() {
        getProject({
          pageIndex: 1,
          pageSize: 1000,
        }).then((res) => {
          this.projectList = res.data;
        });
      },
      // 获取会员列表
      _getUser() {
        getUserAll().then((res) => {
          this.UserList = res.data;
        });
      },
      // 获取列表
      _getData() {
        getCard({
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          card: this.searchType == 1 ? this.searchValue : "",
          phone: this.searchType == 2 ? this.searchValue : "",
        }).then((res) => {
          this.data = res.data.data;
          this.total = res.data.total;
        });
      },
      // 删除
      del(id) {
        this.$Modal.confirm({
          title: "删除确认",
          content: "删除后无法恢复，是否继续？",
          onOk: () => {

            this.delFunction(id);
          },
        });
      },
      // 删除所选
      allDel() {
        let arr = [];
        this.Selection.map(function (item) {
          arr.push(item.id);
        });
        this.del(arr);
      },
      // 删除方法
      delFunction(id) {
        this.loading = true
        delCard({
          id: id,
        }).then((res) => {
          if (res.code == 200) {
            this.$Message.success({
              background: true,
              content: res.msg,
            });
            this._getData();
          } else {
            this.$Message.error({
              background: true,
              content: res.msg,
            });
          }
          this.loading = false

          this.Selection = [];
        });
      },

      //  新增按钮
      addClick() {
        this.edit = false;
        this.showCreate = true;
        this.createData = {
          project_id: "",
          user_id: "0",
          authday: "99999",
          count: "",
        }
      },

      // 新增方法
      addSave() {
        this.$refs.create.validate((valid) => {
          if (valid) {
            postCard({
              project_id: this.createData.project_id,
              user_id: this.createData.user_id,
              authday: this.createData.authday,
              count: this.createData.count,
            }).then((res) => {
              if (res.code == 200) {
                this.$Message.success({
                  background: true,
                  content: res.msg,
                });
                this.$Message.loading({
                    content: "正在努力生成中...",
                    duration: 2,
                });
                this.cardList = res.data
                this.showCard = true
                this._getData();

              } else {
                this.$Message.error({
                  background: true,
                  content: res.msg,
                });
              }
            });
            this.showCreate = false;
            this.creating = false;
            this.$nextTick(() => {
              this.creating = true;
            });
          } else {
            this.creating = false;
            this.$nextTick(() => {
              this.creating = true;
            });
          }
        });
      },




      // 分页跳转
      pageChange(val) {
        this.pageIndex = val;
        this._getData();
      },
      pageSizeChange(val) {
        this.pageSize = val;
        this._getData();
      },
      //多选
      handleSelectChange(val) {
        this.Selection = val;
      },
    },
  };
</script>

<style lang="less" scoped>
  .del {
    text-decoration: line-through;
    color: #999;
  }
</style>